import * as React from 'react'
import scrollTo from '../../utils/scrollTo'

// These should be left outside the component declaration 2 avoid
// performance losses from creating regex each component call.
const telLinkRegex = /^tel:/
const jumpLinkRegex = /^#/
const relativeLinkRegex = /^\/(?!\/)/

const Link = ({
  children,
  to = null,
  CustomLink = null,
  className = null,
  hideCobra, // To prevent warnings of unkown prop on html element
  ...props
}) => {
  const isRelativeLink = relativeLinkRegex.test(to)

  if (isRelativeLink && CustomLink) {
    return (
      <CustomLink className={className} to={to} {...props}>
        {children}
      </CustomLink>
    )
  }

  if (isRelativeLink) {
    return (
      <a className={`leshen-link ${className}`} href={to} {...props}>
        {children}
      </a>
    )
  }

  const isJumpLink = jumpLinkRegex.test(to)
  if (isJumpLink) {
    return (
      <a
        className={`leshen-link ${className}`}
        href={to}
        onClick={(e) => {
          e.preventDefault()
          scrollTo(to)
        }}
      >
        {children}
      </a>
    )
  }

  const isTelLink = telLinkRegex.test(to)

  return (
    // The linter fails to recognize that target="_blank" and rel="noopener noreferrer"
    // will always happen together due to them both relying on the same variable.
    // eslint-disable-next-line react/jsx-no-target-blank
    <>
      {to ? (
        <a
          className={`leshen-link ${className}`}
          href={to}
          target={isTelLink ? null : '_blank'}
          rel={isTelLink ? null : 'noopener noreferrer'}
          {...props}
        >
          {children}
        </a>
      ) : (
        <span className={`leshen-link ${className}`} {...props}>
          {children}
        </span>
      )}
    </>
  )
}

export default Link
